export default "__VITE_ASSET__bN00Xwir__"